module.exports = __webpack_public_path__ + "static/media/back-maroon.d888a552.png";